import React from "react";

const EditableRow = ({
  editFormData,
  handleEditFormChange,
  handleCancelClick,
}) => {
  return (
    <tr>
      <td>
        <input
          type="Date"
          required="required"
          placeholder=""
         name="Date"
          value={editFormData.Date}
          onChange={handleEditFormChange} 
         
          
        ></input>
      </td>
      <td>
        <input
          type="text"
          required="required"
          placeholder="description of follow up"
          name="description"
          value={editFormData.description}
          onChange={handleEditFormChange} 
        ></input>
      </td>
   
      <td>
        <button type="submit">Save</button>
        <button type="button" onClick={handleCancelClick}>
          Cancel
        </button>
      </td>
    </tr>
  );
};

export default EditableRow;